import axios from "axios";
import _ from "lodash";

/**
 * Returns dimensions of a single indicator
 */
export const getDimensions = indicatorId => {
	const indicatorConfig = {
		indicatorId,
		sendDetail: true
	};
	return axios
		.post("/indicator/getDetails", {
			...indicatorConfig
		})
		.then(response => response.data)
		.then(indicatorDetails => {
			return indicatorDetails.indicator[0].calculation[0].dimensions;
		});
};

/**
 * Returns the metric keyword of a single indicator
 */
export const getMetric = indicatorId => {
	const indicatorConfig = {
		indicatorId,
		sendDetail: true
	};
	return axios
		.post("/indicator/getDetails", {
			...indicatorConfig
		})
		.then(response => response.data)
		.then(indicatorDetails => {
			return indicatorDetails.indicator[0].calculation[0].metric;
		});
};

/**
 * Return set of dimensions of all the indicatorIds
 */
export const getDimensionSet = indicatorIds => {
	const dimensionsPromiseArray = indicatorIds.map(indicatorId => getDimensions(indicatorId));
	return Promise.all(dimensionsPromiseArray).then(dimensionsArray => {
		const initialList = dimensionsArray[0].map(dim => dim.dimensionKey);
		const dimensionSet = dimensionsArray.reduce((result, dimensions) => {
			result = _.intersection(
				result,
				dimensions.map(dim => dim.dimensionKey)
			);
			return result;
		}, initialList);
		const indicatorDimensionHash = dimensionsArray.reduce((result, dimensions, index) => {
			result[indicatorIds[index]] = dimensions.map(dim => dim.dimensionKey);
			return result;
		}, {});
		return {
			dimensionSet,
			indicatorDimensionHash
		};
	});
};

/**
 * Return set of metric keywords of all the indicatorIds
 * And a map of IndicatorId as key and metric keyword as value
 */
export const getMetricSet = indicatorIds => {
	const metricsPromiseArray = indicatorIds.map(indicatorId => getMetric(indicatorId));
	return Promise.all(metricsPromiseArray).then(metricArray => {
		const metricSet = metricArray;
		const indicatorMetricHash = metricArray.reduce((result, dimensions, index) => {
			result[indicatorIds[index]] = metricArray[index];
			return result;
		}, {});
		return {
			metricSet,
			indicatorMetricHash
		};
	});
};

/**
 * Returns the indicator table of a single indicator
 */
export const getIndicatorTable = indicatorId => {
	const indicatorConfig = {
		indicatorId,
		seriesOn: [],
		filters: {}
	};
	return axios
		.post("/indicator/getTable", {
			...indicatorConfig
		})
		.then(response => response.data)
		.then(respose => respose.response);
};

/**
 * Returns the indicator series of a single indicator
 */
export const getIndicatorSeries = (indicatorId, seriesOn) => {
	const indicatorConfig = {
		indicatorId,
		seriesOn: seriesOn || [],
		filters: {}
	};
	return axios
		.post("/indicator/getSeries", {
			...indicatorConfig
		})
		.then(response => response.data)
		.then(respose => respose.response);
};

/**
 * Returns the columns of a single query
 */

export const getQueryColumnSet = queryId => {
	return axios
		.post("/api/queries/keywords/", {
			queryId
		})
		.then(response => response.data);
};

export const getSprinkleQueryColumnSet = exploreId => {
	return axios
		.post("/api/indicators/getExternalTableKeywords/", {
			exploreId
		})
		.then(response => response.data);
};

/**
 * Returns the data of a single query
 */

export const getQueryData = (queryId, isExternal) => {
	let indicatorObj = {};
	if (isExternal) {
		indicatorObj["thirdParty"] = {
			exploreId: queryId
		};
		return axios
			.post(`/api/facts/filter`, indicatorObj)
			.then(response => response)
			.then(response => response.data.response);
	} else {
		return axios
			.get("/api/queries/execute/" + queryId)
			.then(response => response.data)
			.then(response => response.data);
	}
};
